import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "export",
  "use": "export-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"export\"><style>#export .st2{fill:none;stroke:#39485b;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}</style><path class=\"st2\" d=\"M298.9 271.2H100.7M199.8 218.9V94M156.5 175.6l43.3 43.3 43.3-43.3M298.9 305.1H100.7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol